import React, { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";

const News = ({ searchQuery = "" }) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleArticles, setVisibleArticles] = useState(15);
  const [selectedArticle, setSelectedArticle] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        setLoading(true);

        const query = searchQuery ? `&q=${searchQuery}` : "";
        const response = await fetch(
          `https://newsdata.io/api/1/news?apikey=pub_65848a3c28fb4c17ca801f2818b6538c7bfd8${query}&category=sports&language=en`
        );
        const data = await response.json();

        if (data.status === "success" && data.results) {
          setArticles(data.results);
        }
      } catch (error) {
        console.error("Error fetching news:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [searchQuery]);

  const handleShowMore = () => {
    setVisibleArticles((prev) => prev + 15);
  };

  if (selectedArticle) {
    return (
      <div className="max-w-3xl mx-auto p-4">
        <button
          onClick={() => setSelectedArticle(null)}
          className="flex items-center gap-2 text-blue-600 font-medium mb-4 hover:text-blue-700 transition"
        >
          <ArrowLeft size={20} />
          Back to News
        </button>

        <article className="bg-white rounded-lg shadow-lg overflow-hidden">
          {selectedArticle.image_url && (
            <img
              src={selectedArticle.image_url}
              alt={selectedArticle.title}
              className="w-full h-64 object-fill"
            />
          )}
          <div className="p-6">
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              {selectedArticle.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm mb-4">
              <span>{new Date(selectedArticle.pubDate).toLocaleDateString()}</span>
              <span className="mx-2">•</span>
              <span>{selectedArticle.source_name}</span>
              {selectedArticle.creator && (
                <>
                  <span className="mx-2">•</span>
                  <span>
                    {Array.isArray(selectedArticle.creator)
                      ? selectedArticle.creator[0]
                      : selectedArticle.creator}
                  </span>
                </>
              )}
            </div>
            <p className="text-gray-600 leading-relaxed mb-4">
              {selectedArticle.description}
            </p>
            <a
              href={selectedArticle.link}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block text-blue-600 font-medium hover:text-blue-700 transition"
            >
              Read full article
            </a>
          </div>
        </article>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="p-4 text-center text-gray-500">
        <span className="animate-pulse">Loading news...</span>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto space-y-8 p-4">
      {articles.slice(0, visibleArticles).map((article, index) => (
        <>
        <div 
  key={article.article_id || index}
  className="bg-white rounded-xl shadow-md overflow-hidden transition transform  hover:shadow-lg duration-300"
>
  <div 
    className="flex flex-col md:flex-row-reverse cursor-pointer" 
    onClick={() => setSelectedArticle(article)}
  >
    {article.image_url && (
      <div className="w-full md:w-48 h-48 md:h-auto relative">
        <img 
          src={article.image_url} 
          alt={article.title} 
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
        />
      </div>
    )}
    <div className="flex-1 p-4">
      <h3 className="font-semibold text-gray-800 text-lg leading-snug mb-2 hover:text-blue-600 transition">
        {article.title}
      </h3>
      {article.description && (
        <p className="text-gray-600 text-sm leading-relaxed mb-3 line-clamp-3">
          {article.description}
        </p>
      )}
      <div className="flex items-center text-gray-500 text-sm space-x-3">
        <div className="flex items-center">
          <span className="text-blue-500 font-medium">{new Date(article.pubDate).toLocaleDateString()}</span>
        </div>
        <span>•</span>
        <span className="font-medium">{article.source_name}</span>
      </div>
    </div>
  </div>
</div>

        </>
      ))}

      {articles.length > visibleArticles && (
        <div className="text-center">
          <button
            onClick={handleShowMore}
            className="text-blue-600 text-sm font-medium hover:text-blue-700 transition"
          >
            Show More
          </button>
        </div>
      )}
    </div>
  );
};

export default News;
